import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as MessagesIcon } from "../../asset/icons/sidebar/messages.svg";
import { ReactComponent as ClubIcon } from "../../asset/icons/sidebar/club.svg";
import { ReactComponent as CommentIcon } from "../../asset/icons/sidebar/comment.svg";
import { ReactComponent as DiscountIcon } from "../../asset/icons/sidebar/discount.svg";
import { ReactComponent as ScanIcon } from "../../asset/icons/sidebar/scan.svg";
import {
    APP_FLAVOR_ORGAN,
    buildOrganBottomNavItems,
    buildUserBottomNavItems,
} from "../../helperData/appFlavor";
import useSideBarList from "./useSideBarList";

function usePanelBottomNav(flavor) {
    const { t } = useTranslation();
    const sidebarList = useSideBarList();

    return useMemo(() => {
        if (flavor === APP_FLAVOR_ORGAN) {
            return buildOrganBottomNavItems({
                sidebarList,
                t,
                scanIcon: <ScanIcon />,
            });
        }
        return buildUserBottomNavItems({
            t,
            icons: {
                messages: <MessagesIcon />,
                participation: <ClubIcon />,
                scan: <ScanIcon />,
                surveys: <CommentIcon />,
                rewards: <DiscountIcon />,
            },
        });
    }, [flavor, sidebarList, t]);
}

export default usePanelBottomNav;
